export class PaginationMetadata {
  total_results_count: number;
  total_pages_count: number;
}
